import { render } from "./UserIcon01.vue?vue&type=template&id=0f57c991&scoped=true"
import script from "./UserIcon01.vue?vue&type=script&lang=js"
export * from "./UserIcon01.vue?vue&type=script&lang=js"

import "./UserIcon01.vue?vue&type=style&index=0&id=0f57c991&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f57c991"]])

export default __exports__